import React from 'react';
const problems = ['You arrive at the court without a real plan', 'You spend hours preparing training before every session', 'You keep searching for new drills online', 'Skill levels in your group vary wildly', "You don't know how to structure a full season progression", 'Sessions always feel improvised'];
export function ProblemSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-191">
      <div className="max-w-3xl mx-auto text-center" data-id="element-192">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-[#0A0A0A] mb-10 tracking-tight leading-tight" data-id="element-193">
          If you coach netball, you're probably living one of these problems:
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left mb-12" data-id="element-194">
          {problems.map((problem, i) => <div key={i} className="flex items-start gap-3 bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-4 shadow-sm" data-id="element-195">
              <span className="text-red-500 text-xl flex-shrink-0" data-id="element-196">❌</span>
              <p className="text-[#0A0A0A] text-sm sm:text-base font-semibold leading-snug" data-id="element-197">
                {problem}
              </p>
            </div>)}
        </div>

        <p className="text-[#6B2FB3] text-2xl sm:text-4xl font-black mb-8 tracking-tight" data-id="element-198">
          How many more sessions do you want to keep improvising?
        </p>

        <div className="h-px bg-gradient-to-r from-transparent via-[#E5E5EA] to-transparent w-full" data-id="element-199" />
      </div>
    </section>;
}